<template>
  <div class="provider-profile-card pb-0" :style="{ width }">
    <div class="row">
      <div class="col-12" v-if="provider">
        <h4 class="provider-profile-card__title m-0">
          {{ provider.provider }}
        </h4>
      </div>
      <div class="col-12" v-if="provider">
        <h3 class="d-inline-block provider-profile-card__players mb-1" v-if="provider && provider.players">
          {{ provider.players.length }} Power Players
        </h3>
      </div>
      <div class="col-12" v-if="provider">
        <h3 class="d-inline-block provider-profile-card__name m-0" v-if="listCountries.length > 0">
          from {{ listCountries.length }} {{ listCountries.length == 1 ? `country` : `countries` }}
        </h3>
        
        <div class="pt-3">
          <a class="btn btn-dark" target="_blank" :href="`https://www.icij.org/investigations/pandora-papers/power-players/?provider=${kebabCase(provider.provider_id)}`">{{ $t('providerProfile.readMore') }} <IconArrowRight /></a>
        </div>

        <div class="mt-4 pb-3 text-center">
          <CustomSharingOptions :title="`${$t('social.provider')} ${provider.provider}`" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CustomSharingOptions from '@/components/CustomSharingOptions'
import IconArrowRight from '@/components/IconArrowRight'
import kebabCase from 'lodash/kebabCase'
import utils from '@/mixins/utils'

export default {
  name: 'ProviderProfileCard',
  mixins: [utils],
  props: {
    provider: {
      type: Object
    },
    width: {
      type: String,
      default: '100%'
    },
    listCountries: {
      type: [Array]
    }
  },
  components: {
    IconArrowRight,
    CustomSharingOptions
  },
  data() {
    return {
      enableFooter: true
    }
  },
  methods: {
    kebabCase
  }
}
</script>

<style lang="scss">
  .provider-profile-card {
    margin: 0 auto;
    padding: 14px 20px;

    &__player_image {
      position: relative;
      height: 280px;
      width: 260px;
      margin: 0 auto;
    }

    &__image {
      width: auto;
      height: 220px;
      background: var(--app-color-black);
      border-radius: 100%;
      overflow: hidden;
    }

    &__logo {
      position: absolute;
      width: 100%;
      max-width: 120px;
      bottom: 15px;
      left: 0;
    }

    &__players {
      display: inline-block;
      font-size: 21px;
      font-weight: 900;
      padding: 3px;
      color: var(--app-color-black);
    }

    &__name {
      display: inline-block;
      font-size: 18px;
      font-weight: 600;
      padding: 3px;
      color: var(--app-color-white);
      background: var(--app-color-red);
    }

    &__title {
      color: var(--app-color-black);
      font-size: 61px;
      font-weight: 900;
    }

    &__read-more, &__read-more:hover {
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
</style>
